import { Users, Target, Compass } from "lucide-react";

const PILLARS = [
  {
    icon: Users,
    title: "Quiénes somos",
    text: "Despacho multidisciplinario de contadores, fiscalistas y consejeros certificados, con presencia en Guadalajara, CDMX (Torre Mayor)",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/txov9my9_quienes-somos.jpg",
  },
  {
    icon: Target,
    title: "Qué hacemos",
    text: "Acompañamos a la empresa familiar mexicana en las decisiones que normalmente postergan: estructura corporativa, sucesión, gobierno, blindaje patrimonial y planeación fiscal de largo plazo.",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/8imrsw22_que-hacemos.jpg",
  },
  {
    icon: Compass,
    title: "Cómo lo hacemos",
    text: "Como consejeros, no como proveedores. Confrontamos antes de que los problemas escalen, en lugar de reaccionar cuando ya están dentro.",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/g9klp9f1_como-hacemos.jpg",
  },
];

export default function Nosotros() {
  return (
    <section id="nosotros" data-testid="nosotros-section" className="py-20 sm:py-28 relative">
      <div className="rp-container">
        <div className="rp-reveal max-w-3xl">
          <span className="rp-kicker">Nosotros</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" style={{ color: "var(--rp-ink)" }}>
            Asesoría patrimonial y <span className="rp-gradient-text">gobierno corporativo</span>, no contabilidad transaccional.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
            Contadores RP atiende a empresas familiares mexicanas que ya pasaron la fase de supervivencia y
            enfrentan las preguntas que normalmente se postergan: cómo se ordena la dirección, cómo se sucede,
            cómo se blinda lo construido. Trabajamos como consejeros externos de largo plazo.
          </p>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Bajo la dirección de{" "}
            <a
              href="https://www.linkedin.com/in/juan-pablo-rodriguez-garcia-bb3a52370/"
              target="_blank"
              rel="noreferrer"
              data-testid="director-linkedin-link"
              className="font-semibold underline decoration-2 underline-offset-4 transition-colors"
              style={{ color: "var(--rp-blue)", textDecorationColor: "var(--rp-green)" }}
            >
              Juan Pablo Rodríguez García
            </a>
            , contador público, AD1 IPADE y consejero certificado por el IMMPC.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            const accent =
              i === 1
                ? "var(--rp-green)"
                : i === 2
                ? "var(--rp-teal)"
                : "var(--rp-blue)";
            const accentBg =
              i === 1
                ? "rgba(50,138,87,0.1)"
                : i === 2
                ? "rgba(0,191,165,0.12)"
                : "rgba(71,118,185,0.1)";
            return (
              <div
                key={i}
                data-testid={`nosotros-pillar-${i}`}
                className="rp-card rp-reveal overflow-hidden flex flex-col"
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <div className="relative h-48 sm:h-52 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                  />
                  <div
                    className="absolute inset-0"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(60,57,80,0) 35%, rgba(60,57,80,0.55) 100%)",
                    }}
                  />
                  <div
                    className="absolute top-4 left-4 w-11 h-11 rounded-xl flex items-center justify-center backdrop-blur-md"
                    style={{ background: accentBg, border: `1px solid ${accent}33` }}
                  >
                    <Icon className="w-5 h-5" style={{ color: accent }} />
                  </div>
                </div>
                <div className="p-7">
                  <h3 className="text-xl font-bold mb-3" style={{ color: "var(--rp-ink)" }}>{p.title}</h3>
                  <p className="text-slate-600 leading-relaxed text-sm">{p.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
